import { render, staticRenderFns } from "./PurchaseImportName.vue?vue&type=template&id=2d4d76ae&scoped=true&"
import script from "./PurchaseImportName.vue?vue&type=script&lang=js&"
export * from "./PurchaseImportName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4d76ae",
  null
  
)

export default component.exports